import React from "react";
import { BadgeCheck } from "lucide-react";
import { Stagger, StaggerItem } from "../components/Reveal";

const PARTNERS = [
  { n: "Amazon", tag: "Service Provider Network" },
  { n: "Flipkart", tag: "Seller Partner" },
  { n: "Meesho", tag: "Supplier Services" },
  { n: "Myntra", tag: "PPMP Onboarding" },
  { n: "Ajio", tag: "Business Portal" },
  { n: "JioMart", tag: "Seller Onboarding" },
  { n: "Snapdeal", tag: "Catalog Partner" },
];

export default function Partners() {
  return (
    <section className="py-16 bg-white border-b border-[#E5E5E5]" data-testid="partners-section">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <p className="font-mono text-[10px] uppercase tracking-[0.3em] text-gray-400 mb-8">Marketplace partner programs we work inside</p>
        <Stagger className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-7 gap-3" stagger={0.05}>
          {PARTNERS.map((p) => (
            <StaggerItem key={p.n} className="border border-[#E5E5E5] rounded-md p-4 hover:border-[#6B1414] hover:-translate-y-1 transition-all duration-300 bg-[#FAFAFA]">
              <div className="flex items-center gap-1.5 text-[#2E3A9E] mb-2"><BadgeCheck size={14} /><span className="font-mono text-[9px] uppercase tracking-wider">Verified</span></div>
              <p className="font-heading text-lg font-black text-[#0A0A0A] leading-none">{p.n}</p>
              <p className="font-body text-[11px] text-gray-500 mt-1">{p.tag}</p>
            </StaggerItem>
          ))}
        </Stagger>
      </div>
    </section>
  );
}
